<template>
  <div v-if="render">
    <!-- <template v-for="(item, index) in content">
      <ContentEditable
        :id="'content-item-' + index"
        :ref="'content-item-ref-' + index"
        v-model="content[index]"
        :editable="editable"
        :key="index"
        @click="selected($event, index)"
        v-on:keydown="keyPress($event, index)"
      />
    </template> -->

    <draggable
      v-model="content"
      group="content"
      @start="drag = true"
      @end="dragEnd"
      class="content mx-4"
      handle=".handle"
    >
      <template v-for="(item, index) in content">
        <content-editable
          :id="'content-item-' + index"
          :ref="'content-item-ref-' + index"
          v-model="content[index]"
          :editable="content[index]['editable']"
          :key="item.key"
          @mouseenter="selected($event, index)"
          v-on:keydown="keyPress($event, index)"
        >
          <v-icon class="handle">mdi-drag-vertical</v-icon>
        </content-editable>
      </template>
    </draggable>
    <v-btn @click="editable = !editable">Edit</v-btn>
    <v-btn @click="deleteElement(1)">Delete</v-btn>
    <v-btn @click="setCursor(1, 355)">Set Cursor</v-btn>

    <!-- <v-btn @click="render = !render">Re Render</v-btn>
    <v-btn @click="addElement">Add</v-btn> -->
    <v-container>
      <tree-view :data="content" :options="{ maxDepth: 3 }"></tree-view>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import TreeView from "vue-json-tree-view";
Vue.use(TreeView);

export default {
  name: "ContentBuilder",
  props: {
    value: {
      type: Array,
    },
  },
  components: {
    ContentElements: () => import("./components/ContentElements.vue"),
    ContentEditable: () => import("./components/ContentEditable.vue"),
    Draggable: () => import("../../../node_modules/vuedraggable"),
  },
  data() {
    return {
      drag: false,
      content: null, // content or page array
      render: true,
      defaultElement: {
        tag: "p",
        innerHtml: "New Content",
      },
      selectedIndex: null,
      selectedElement: null,
      selectedPos: null,
      showMenu: false,
      items: [
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me 2" },
      ],
    };
  },
  computed: {
    totalElements() {
      return this.content.length;
    },
  },
  watch: {
    content: {
      deep: true,
      handler(newVal, oldVal) {
        if (oldVal) {
          this.$emit("input", this.content);
        }
      },
    },
  },
  methods: {
    selected(e, index) {
      //console.log("selected", e, index);
      let el = e.target;
      window.testE = el;
      this.selectedIndex = index;
      this.content[index]["editable"] = true; //  MAKE EDITABLE
      this.updateContent();
      this.selectedPos = el.getBoundingClientRect();
      console.log("selectedPos", this.selectedPos);
      this.selectedElement = e.target;

      //setTimeout(() => this.countLines(), 1000);
      //   this.countLines();
      //   this.calcCharsPerLine();
      // let el = this.$el;

      // let caretPos = this.getCaretCoordinates();
      //   var x = e.clientX;
      //   var y = e.clientY;
      //   let mouse = { "X coords: ": x, "Y coords: ": y };
      // console.log("position", this.position);
      //console.log("mouse", mouse);
      //console.log("caretPos", caretPos);
    },
    deSelect(index) {
      //this.content[index]["editable"] = false;
      this.updateContent();
    },
    keyPress(e) {
      //console.log("keypress", e);
      let keyPress = e.key; // key pressed
      let index = this.selectedIndex; // selected Index
      // includ special keys
      ["shiftKey", "ctrlKey", "altKey"].forEach((key) => {
        if (e[key]) {
          keyPress = `${key}+${keyPress}`;
        }
      });
      let cursorPos = this.getCursorPosition();
      let cursorXY = this.getCaretCoordinates();
      //   console.log("elPos", elPos);
      /* eslint-disable */
      // DEFAULT PAYLOAD
      let payload = {
        el: e.target,
        cursorPos: cursorPos,
        index: index,
        action: null,
      };

      switch (keyPress) {
        // [ENTER] Adds new element to page
        case "Enter":
          e.preventDefault(); // prevent default
          payload.action = "add"; // add action
          this.element_action(payload);
          break;
        case "Shift+Enter":
          e.preventDefault(); // prevent default
          payload.action = "line-break"; // add action
          break;
        case "Backspace": // Deletes element if cursor is at the beginning of element
          if (pos === 0) {
            e.preventDefault(); // prevent default
            let payload = {
              el: el,
              cursorPos: pos,
              index: index,
              action: "delete",
            };
            this.element_action(payload);
          }

          break;
        case "ArrowUp":
          let top = this.selectedPos.top; // top position of
          if (index > 0 && cursorXY.y >= top) {
            console.log("cursoryXy", cursorXY);
            console.log("this.selectedPos", this.selectedPos);
            let targetIndex = index - 1; // creates index of previous element
            var targetEl = this.content[targetIndex]; // get's previous element
            let contentLength = targetEl.innerHtml.length;
            cursorPos = cursorPos <= contentLength ? cursorPos : contentLength;
            //console.log("keyPress ArrowUp", targetIndex, cursorPos);
            this.setCursor(targetIndex, cursorPos);
            //this.setCursorByEl(targetEl, pos);
          }
          break;
        case "ArrowDown":
          console.log("test arrowdwon", index < this.totalElements - 1);
          if (index < this.totalElements - 1) {
            let targetIndex = index + 1;
            this.setCursor(targetIndex, 100);
          }
          break;
        default:
          console.log("Unknown KeyPress", keyPress);
          return;
        // code block
      }
    },
    element_action(payload) {
      switch (payload.action) {
        case "add":
          this.addElement(payload);
          break;
        case "line-break":
          this.addLineBreak(payload);
          break;

        case "delete":
          this.deleteElement(payload);
          break;
        default:
          break;
      }
    },
    //#region ELEMENT ACTIONS
    addLineBreak(payload) {
      // TODO: NOT USED -
      let cursorPos = payload.cursorPos;
      let index = payload.index;
      let innerHtml = payload.innerHtml;

      function addToStr(str, pos, stringToAdd) {
        return (
          str.substring(0, pos) + stringToAdd + str.substring(pos, str.length)
        );
      }
      let _innerHtml = addToStr(innerHtml, cursorPos, "<br");
    },
    addElement(payload) {
      let el = payload.el;
      let newEl = {};
      let elContent = el.innerText;
      let contentLength = elContent.length;
      let cursorPos = payload.cursorPos;
      let currentElindex = payload.index;
      let targetIndex = currentElindex + 1;

      if (cursorPos == contentLength) {
        // add new line with placeholder content
        newEl = {
          tag: "p",
          innerHtml: "Enter Content",
        };
      } else if (contentLength > cursorPos) {
        // if the cursor is not at the end of content cut the content and add to newline
        newEl = {
          tag: "p",
          innerHtml: elContent.slice(cursorPos, contentLength),
        };
        // removes the cut content from original element
        this.content[currentElindex].innerHtml = elContent.slice(0, cursorPos);
      }
      this.render = false;
      this.$nextTick(() => {
        this.content.splice(targetIndex, 0, newEl); // place after current element
        this.render = true;
        this.$nextTick(() => {
          this.setCursor(targetIndex);
          window.focus();
        });
      });
    },
    deleteElement(payload) {
      let index = payload.index;
      var _content = JSON.parse(JSON.stringify(this.content)); // make copy of content to manipulate
      // IF YOUR AT THE TOP OF CONTENT JUST RETURN
      if (index === 0 && _content.length === 1) {
        return;
      }
      var targetIndex = index == 0 ? index : index - 1; // gets previous element index if not the last element
      var currentEl = _content[index];
      var previousEl = _content[targetIndex];
      let previousElcaretPos =
        index == 0 ? index : previousEl.innerHtml.length + 1;
      if (previousEl) {
        previousEl.innerHtml = `${previousEl.innerHtml}  ${currentEl.innerHtml}`; // add any content to previous element
      }
      _content.splice(index, 1); // delete element
      this.content = _content; // replace with adjusted content
      this.render = false;

      this.$nextTick(() => {
        this.render = true;
        this.$nextTick(() => {
          // SET CURSOR AFTER RENDERED
          // console.log("target", this.$refs, index);
          // console.log("target", targetIndex, previousElcaretPos);
          this.setCursor(targetIndex, previousElcaretPos);
          window.focus();
        });
      });
    },
    //#endregion ELEMENT ACTIONS
    countLines() {
      var el = document.querySelector(
        `#content-item-${this.selectedIndex} > [contenteditable="true"]`
      );

      let fontSize = window
        .getComputedStyle(el, null)
        .getPropertyValue("font-size");

      console.log("el", el, fontSize);
      var divHeight = el.offsetHeight;
      var lineHeight = parseInt(
        window.getComputedStyle(el, null).getPropertyValue("line-height")
      );
      var lines = divHeight / lineHeight;
      console.log(`lineHeight: ${lineHeight}`);
      console.log(`There are ${lines} lines in the dom`);
    },
    calcCharsPerLine() {
      var el = this.selectedElement;
      var targetWidth = el.clientWidth;
      var targetText = el.innerText.replace(/\s/gm, "");
      var fontFamily = window
        .getComputedStyle(el, null)
        .getPropertyValue("font-family");
      var fontSize = window
        .getComputedStyle(el, null)
        .getPropertyValue("font-size");

      var targetFont = `${fontSize} ${fontFamily}`;

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      ctx.font = targetFont;
      let textWidth = Math.round(ctx.measureText(targetText).width * 100) / 100;
      const avgCharWidth =
        Math.round((textWidth / targetText.length) * 100) / 100;
      const singleCharsPerLine = targetWidth / avgCharWidth;
      console.log("targetText", targetText);
      console.log("textWidth", textWidth);
      console.log("targetText.length", targetText.length);
      console.log("avgCharWidth", avgCharWidth);
      console.log("singleCharsPerLine", singleCharsPerLine);
    },
    //#region Cursor/Caret Methods
    setCursor(targetIndex, pos) {
      document.querySelector("body").focus();
      targetIndex = targetIndex ? targetIndex : this.selectedIndex;
      pos = parseInt(pos) > 0 ? pos : 0; // set to 0 if not defined
      console.log("setCursor", targetIndex, pos);
      var el = document.querySelector(
        `#content-item-${targetIndex} > [contenteditable]`
      );
      el.style.contentEditable = true;
      el.click();
      //console.log("setCursor el", el);
      var range = document.createRange();
      var sel = window.getSelection();
      range.setStart(el.childNodes[0], pos); // set cursor to position of element;
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
      el.focus();
      window.focus();
    },
    setCursorByEl(targetEl, pos) {
      pos = parseInt(pos) > 0 ? pos : 0; // set to 0 if not defined
      console.log("setCursor", targetEl, pos);
      var el = targetEl;
      //console.log("setCursor el", el);
      var range = document.createRange();
      var sel = window.getSelection();
      range.setStart(el.childNodes[0], 83); // set cursor to position of element;
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
      el.focus();
      window.focus();
    },
    // getCursorPosition(editableDiv) {
    getCursorPosition() {
      let editableDiv = this.selectedElement;
      var cursorPos = 0,
        sel,
        range;
      if (window.getSelection) {
        sel = window.getSelection();
        if (sel.rangeCount) {
          range = sel.getRangeAt(0);
          if (range.commonAncestorContainer.parentNode == editableDiv) {
            cursorPos = range.endOffset;
          }
        }
      } else if (document.selection && document.selection.createRange) {
        range = document.selection.createRange();
        if (range.parentElement() == editableDiv) {
          var tempEl = document.createElement("span");
          editableDiv.insertBefore(tempEl, editableDiv.firstChild);
          var tempRange = range.duplicate();
          tempRange.moveToElementText(tempEl);
          tempRange.setEndPoint("EndToEnd", range);
          cursorPos = tempRange.text.length;
        }
      }
      return cursorPos;
    },
    getCaretCoordinates() {
      let x = 0,
        y = 0;
      const isSupported = typeof window.getSelection !== "undefined";
      if (isSupported) {
        const selection = window.getSelection();
        if (selection.rangeCount !== 0) {
          const range = selection.getRangeAt(0).cloneRange();
          range.collapse(true);
          const rect = range.getClientRects()[0];
          if (rect) {
            x = rect.left;
            y = rect.top;
          }
        }
      }
      return { x, y };
    },
    // LAB-EX
    click: (x, y) => {
      const ev = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true,
        screenX: x,
        screenY: y,
      });
      const el = document.elementFromPoint(x, y);
      el.dispatchEvent(ev);
    },
    //#endregion Cursor/Caret Methods
    reRender() {
      this.render = false;
      this.$nextTick(() => (this.render = true));
    },
    updateContent() {
      const _content = JSON.parse(JSON.stringify(this.content));
      this.content = _content;
    },
    dragEnd() {
      this.render = false;
      this.drag = false;
      // resort content
      this.$nextTick(() => {
        this.content.forEach((item, index) => {
          item["key"] = index;
        });
        this.render = true;
      });
    },
  },
  mounted() {
    // this.$nextTick(() => {
    //   console.log("content builder mounted", this, this.$children);
    // });
    // let content = this.content;
    this.content = JSON.parse(JSON.stringify(this.value));
    this.content.forEach((item, index) => {
      item["key"] = index;
      item["editable"] = false;
      console.log(item);
    });
    window.content = this.content;
  },
};
</script>

<style lang="scss">
.tree-view-wrapper {
  overflow: hidden !important;
}
div[id^="content-item"] {
  position: relative;
  z-index: 99999999;
  .handle {
    position: absolute;
    cursor: pointer;
    left: -20px;
    top: 0.5rem;
  }
}
// *[contenteditable="true"] {
//   background-color: rgba(217, 245, 255, 0.5);
//   outline: 0;
// }
.content {
  .handle {
    opacity: 0;
    &:hover {
      opacity: 1;
    }
  }
}
</style>
